export const GENERAL_ERROR_TITLE = 'Error';
export const GENERAL_ERROR_MESSAGE = 'Something went wrong';
export const ACCESS_DENIED_TITLE = 'Access denied';
export const ACCESS_DENIED_MESSAGE =
  "This account doesn't have access to Treat Canary Console";
export const ADD_USER_ERROR_TITLE = 'Add a user';
export const USER_IS_ALREADY_IN_CANARY_LIST_MESSAGE =
  'User is already in Canary list';
export const DELETE_USER_ERROR_TITLE = 'Delete a user';
export const USER_TO_DELETE_IS_NOT_FOUND_MESSAGE =
  "User with specified userLogin doesn't exist";
export const START_CANARY_TITLE = 'Start Canary';
export const FULL_START_CANARY_TITLE = 'Full Start Canary';
export const GOING_TO_GA_TITLE = 'Convert Canary to GA';
export const COMPLETE_CANARY_TITLE = 'Complete Canary';
export const TERMINATE_CANARY_TITLE = 'Terminate Canary';
export const CHOOSE_ANOTHER_FILE_MESSAGE = 'Choose some other file';
export const ADD_A_FILE_TITLE = 'Add a file';
export const DELETE_FROM_FILE_TITLE = 'Delete from file';
export const ADD_A_FILE_SUCCESS_MESSAGE = 'File has been uploaded';
export const DOWNLOAD_NOT_FOUND_USERS_MESSAGE =
  ' a file with a list of not found users';
export const USER_MANUAL = 'User Manual';
export const LOG_OUT = 'Log Out';
export const USER_MANUAL_LINK =
  'https://wiki.aligntech.com/display/CLWEB/Canary+Console.+User+Guide';
export const BASE_DOMAIN_DEV = 'smarthub.dev';
export const BASE_DOMAIN_STG = 'smarthub.stg';
export const BASE_DOMAIN_PRD = 'smarthub';
export const HOSTED_ZONE_GLOBAL = 'aligntech.com';
export const HOSTED_ZONE_CHINA = 'invisalign.net.cn';
